var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H11.9C11.7 0.9 10.7 0 9.5 0C8.3 0 7.3 0.9 7.1 2H0V3H7.1C7.3 4.1 8.3 5 9.5 5C10.7 5 11.7 4.1 11.9 3H14V2ZM9.5 4C8.7 4 8 3.3 8 2.5C8 1.7 8.7 1 9.5 1C10.3 1 11 1.7 11 2.5C11 3.3 10.3 4 9.5 4ZM0 10H2.1C2.3 11.1 3.3 12 4.5 12C5.7 12 6.7 11.1 6.9 10H14V9H6.9C6.7 7.9 5.7 7 4.5 7C3.3 7 2.3 7.9 2.1 9H0V10ZM4.5 8C5.3 8 6 8.7 6 9.5C6 10.3 5.3 11 4.5 11C3.7 11 3 10.3 3 9.5C3 8.7 3.7 8 4.5 8Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.fe71e86b8953ceb3a3551fe357849397.svg";
export { ForwardRef as ReactComponent };